const EditUser = () => {
  return <></>;
};

export default EditUser;
